import AxiosInstance from 'src/shared/services/axios/interceptor';
import { SendingDate } from 'src/modules/sending/models/sendingDate';
import { Sending } from 'src/modules/sending/models/sending';
import { SendingOrder } from 'src/modules/sending/models/sendingOrder';
import { SendingOrderCreate } from 'src/modules/sending/models/sendingOrderCreate';
import { SendingOrderProduct } from 'src/modules/sending/models/sendingOrderProduct';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';

const controller = 'Sending';

export const getAllSendingDates = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `SendingDate/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<SendingDate>>(endpoint);
};

export const getAllSendingOrderProduct = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `SendingOrderProduct/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<SendingOrderProduct>>(endpoint);
};

export const getAllSendingOrder = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `SendingOrder/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<SendingOrder>>(endpoint);
};

export const deleteSendingOrder = (id) => {
  const endpoint = `SendingOrder?id=${id}`;
  return AxiosInstance.delete<SendingOrder>(endpoint);
};

export const updateSendingOrder = (sendingOrder: SendingOrder) => {
  const endpoint = `SendingOrder`;
  return AxiosInstance.put<SendingOrder>(endpoint, sendingOrder);
};

export const saveSendingOrder = (sendingOrder: SendingOrderCreate) => {
  const endpoint = `SendingOrder`;
  return AxiosInstance.post<SendingOrderCreate>(endpoint, sendingOrder);
};

export const getSendingById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Sending>(endpoint);
};

export const getSendingOrderById = (id) => {
  const endpoint = `SendingOrder/${id}`;
  return AxiosInstance.get<SendingOrder>(endpoint);
};
